<template>
	<div class="consult-label-list">
		<div v-if="message_list.length" class="scroll-view" scroll-y="true" style="height: 100%;" :show-scrollbar="false"  :refresher-enabled="true" :refresher-triggered="is_refresh"  @scrolltolower="scroll_bottom" @refresherrefresh="refresh">
			<consult-label class="good-cell" :style="`width:100%;`" v-for="message in message_list" :key="`messagelist-${message.id}`" :message="message"></consult-label>
			
			<!-- <no-more v-if="no_more_data"></no-more> -->
		</div>
		
		<!-- <view class="no-more">{{$t('goods.nodata')}}</view> -->
	</div>
</template>

<script>
	import ConsultLabel from "./consultLabel.vue";
	// import NoData from "../noMore/nodata.vue";
	export default {
		name:'consult-label-list',
		components:{
			ConsultLabel,
			// NoData
		},
		props: {
			message_list: {
				type: Array,
				default: []
			},
		},
		data() {
			return {
				no_more_data: false,
				is_refresh:false
			}
		},
		methods: {
			scroll_bottom() {
				
			},
			refresh(){
				
			}
		},
	}
</script>

<style lang="less">
	.consult-label-list{
		height: 100%;
	}
</style>